import { Link } from 'react-router-dom';
import LinkItem from 'components/common/Link';
import ROUTES from 'constants/routes';

const LocationNav = ({ buttonText, buttonLinkText }) => {
    return (
        <Link to={ROUTES.location} className="home-locations-navitem">
            <div className="button-text">{buttonText}</div>
            <LinkItem text={buttonLinkText} />
        </Link>
    );
};

export default LocationNav;
